/**
 * 供應商配送範圍判定（前端）。
 *
 * 語意必須與後端 available-suppliers.service.ts 的 supplierCovers() 完全一致：
 *   - delivery_areas 未提供或為空陣列 → 全部可送（未設定範圍視為不限）
 *   - 縣市比對前雙邊正規化「臺→台」
 *   - 命中縣市後：all_sites === true 可送；否則 sites 包含該區才可送
 *
 * area 對應後端的 site_id（鄉鎮市區）。
 */

/** bootstrap available_suppliers[].delivery_areas 的單筆項目 */
export interface DeliveryArea {
  city: string;
  all_sites: boolean;
  sites: string[];
}

/** 臺→台 正規化，讓「臺北市」與「台北市」視為相同 */
const normalizeCity = (value: string): string => (value || "").replace(/臺/g, "台");

/**
 * 判斷指定 city/area 是否在此瓦斯行的配送範圍內。
 *
 * @param deliveryAreas 供應商配送範圍（未提供或空 → 全部可送）
 * @param city          使用者選的縣市
 * @param area          使用者選的鄉鎮市區（後端 site_id）
 * @returns true = 可配送
 */
export const isAddressDeliverable = (
  deliveryAreas: DeliveryArea[] | undefined,
  city: string,
  area: string,
): boolean => {
  // 未設定配送範圍（undefined 或空陣列）→ 全部可送
  if (!deliveryAreas || deliveryAreas.length === 0) return true;

  const normalizedCity = normalizeCity(city);
  const matchedArea = deliveryAreas.find((entry) => normalizeCity(entry.city) === normalizedCity);

  // 縣市不在配送清單 → 不可送
  if (!matchedArea) return false;

  // 該縣市全區可送
  if (matchedArea.all_sites === true) return true;

  // 否則須該鄉鎮市區在 sites 清單內
  return (matchedArea.sites || []).includes(area);
};
